import { extractGiftCode } from '@activities/gift/_shared/giftCode';
import useRegisterGift from '@activities/gift/_shared/useRegisterGift';
import useNativeListener from '@hooks/native/useNativeListener';
import useLoading from '@hooks/ui/useLoading';
import { getBarcodeData } from '@utils/nativeUtils';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

function useRegisterByImage() {
    const { t } = useTranslation('gift');
    const { startLoading, stopLoading } = useLoading();
    const { register } = useRegisterGift(stopLoading, (message) => {
        stopLoading();
        toast.error(message);
    });

    const handleRecognizedCode = (code?: string | null) => {
        if (code) {
            register(code);
            return;
        }
        stopLoading();
        toast.error(t('newGift.recognitionFailed'));
    };

    const handleByInput = () => {
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = 'image/*';
        input.hidden = true;
        input.addEventListener('change', async () => {
            const file = input.files?.[0];
            input.remove();
            if (!file) return;
            startLoading();
            const code = await import('tesseract.js')
                .then(({ default: Tesseract }) => Tesseract.recognize(file, 'eng'))
                .then(({ data }) => extractGiftCode(data.text))
                .catch(() => undefined);
            handleRecognizedCode(code);
        });
        document.body.append(input);
        input.click();
    };

    const handleSelectImage = () => {
        getBarcodeData({
            onError: handleByInput,
            onSuccess: startLoading,
        });
    };

    useNativeListener('getBarcodeData', handleRecognizedCode, [handleRecognizedCode]);

    return { handleSelectImage };
}

export default useRegisterByImage;
